import { motion, AnimatePresence } from "framer-motion";
import { WifiOff, RefreshCw } from "lucide-react";
import { useNetworkStatus } from "@/lib/network";

export const OfflineBanner = () => {
    const isOnline = useNetworkStatus();

    return (
        <AnimatePresence>
            {!isOnline && (
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -50 }}
                    transition={{ duration: 0.3 }}
                    className="fixed top-0 left-0 right-0 z-50 bg-amber-500/90 backdrop-blur-md text-white text-xs font-semibold px-4 py-2 flex items-center justify-center gap-2 shadow-lg border-b border-amber-400/30"
                >
                    <WifiOff className="w-4 h-4 animate-pulse" />
                    <span>You are currently offline. Some features may be limited.</span>
                    <div className="flex items-center gap-1 opacity-80 text-[10px] uppercase tracking-wider ml-2 bg-amber-600/50 px-2 py-0.5 rounded-full">
                        <RefreshCw className="w-3 h-3 animate-spin" />
                        <span>Reconnecting</span>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default OfflineBanner;
